import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Visualization() {
  return <section className="px-6 py-10 max-w-3xl mx-auto relative" data-id="element-242">
      {/* Soft background effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#C4A265]/5 to-transparent pointer-events-none" data-id="element-243"></div>

      <FadeIn data-id="element-244">
        <div className="space-y-6 text-xl md:text-2xl leading-relaxed text-[#2D2A26] font-serif italic text-center" data-id="element-245">
          <p data-id="element-246">Cierra los ojos por un momento.</p>

          <p data-id="element-247">Imagina mañana por la mañana.</p>

          <p className="text-[#2D2A26]/70" data-id="element-248">
            No el despertador como un golpe en el pecho.
          </p>
          <p className="text-[#2D2A26]/70" data-id="element-249">
            No el inventario automático de todo lo que puede salir mal.
          </p>
          <p className="text-[#2D2A26]/70" data-id="element-250">
            No esa sensación de que ya empezaste el día perdiendo.
          </p>

          <p className="font-bold not-italic text-2xl md:text-3xl text-[#4A5D3A] pt-4" data-id="element-251">
            Solo tú.
          </p>

          <p data-id="element-252">Con tu café o tu agua tibia.</p>

          <p className="font-bold not-italic text-[#9B4F2B]" data-id="element-253">
            Y una versión de ti que anoche realmente descansó.
          </p>

          <p className="not-italic text-lg md:text-xl" data-id="element-254">
            Más tranquila. Más entera. Más tú.
          </p>

          <div className="not-italic text-lg md:text-xl space-y-5 pt-6 text-left max-w-2xl mx-auto" data-id="element-255">
            <p data-id="element-256">
              Las personas a tu alrededor van a notar algo diferente. No sabrán
              exactamente qué es. Pero lo van a sentir.
            </p>

            <p data-id="element-257">
              Porque la mujer calmada, presente y entera que quieres ser no nace
              de la fuerza de voluntad ni de "esforzarte más".
            </p>

            <p className="font-bold text-2xl text-[#4A5D3A] text-center my-8 border-y border-[#4A5D3A]/20 py-6" data-id="element-258">
              Nace de un sistema nervioso que por fin recibió la señal de que
              puede soltar.
            </p>

            <p className="text-center font-bold text-[#9B4F2B]" data-id="element-259">
              Eso — exactamente eso — está del otro lado de esta decisión.
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}